module.exports = __webpack_public_path__ + "static/media/hdgz@2x.7b081888.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/hdgz@2x.png
// module id = 1760
// module chunks = 0 1